import { getEndpoint } from '@mecontrol/endpoint';
import { useEffect, useState } from 'react';
/** Gets the mecontrol scripts from the official endpoint and attaches it
 * to the current page.
 */
export const useMeControlScript = () => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        if (globalThis.msrcMeControlContent) {
            if (!ready) {
                setReady(true);
            }
            return;
        }
        globalThis.msrcMeControlContent = getEndpoint({
            partner: 'MSMSRC',
            debug: false,
        });
        const meControlScript = document.createElement('script');
        meControlScript.async = false;
        meControlScript.src = globalThis.msrcMeControlContent;
        meControlScript.onload = () => {
            setReady(true);
        };
        document.body.appendChild(meControlScript);
    }, [ready]);
    return { ready };
};
